export default __webpack_public_path__ + "static/cultimedia-c911ac002204dd355db6eef89c0c69dd.png";